import { IComponentOptions, IController, IScope } from 'angular';
import './gmc-chips-2.component.scss';
import { Helpers } from '../../../helpers';
import { cloneDeep } from 'lodash-es';

class GmcChips2Controller implements IController {
  helpers = Helpers;
  values: string[] = [];
  onDelete: (obj: any) => void;
  limit: number = 3;
  letterLimit: number = 5;

  constructor() {
  }

  $onInit() {
  }

  transformValue(value) {
    return this.helpers.cutMessagePreview(value, this.letterLimit);
  }

  removeItem(index) {
    this.onDelete({index: index});
  }
}

export const GmcChips2Component: IComponentOptions = {
  controller: GmcChips2Controller,
  template: require('./gmc-chips-2.component.html'),
  bindings: {
    values: '<',
    limit: '<?',
    letterLimit: '<?',
    onDelete: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-chips-2/gmc-chips-2.component.ts